import { render, staticRenderFns } from "./number.vue?vue&type=template&id=6dee815a"
import script from "./number.vue?vue&type=script&lang=ts"
export * from "./number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports